<template>
  <div v-if="banners.length > 0" class="banners">

    <div ref="carouselEl" id="carouselExampleIndicators" class="carousel slide custom-carousel carousel-fade">
      <!-- Indicadores -->
      <div class="carousel-indicators">
        <button v-for="(banner, index) in banners" :key="'indicator-' + index" type="button"
          data-bs-target="#carouselExampleIndicators" :data-bs-slide-to="index" :class="{ active: index === 0 }"
          :aria-current="index === 0 ? 'true' : null" :aria-label="'Slide ' + (index + 1)"></button>
      </div>

      <!-- Slides -->
      <div class="carousel-inner">
        <div v-for="(banner, index) in banners" :key="'slide-' + index" class="carousel-item"
          :class="{ active: index === 0 }" :data-bs-interval="getInterval(banner.image)">
          <img :src="`img/banners/${banner.image}`" class="d-block w-100 imgbanner" :alt="banner.description"
            loading="lazy" />
        </div>
      </div>

      <!-- Controles -->
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </button>

      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next">
        <span class="carousel-control-next-icon"></span>
      </button>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Carousel from 'bootstrap/js/dist/carousel';
import { cacheImage, getCachedImage } from '../utils/imageCache.js';

export default {
  data() {
    return {
      videoUrl: '',
      selectedBanner: 0,
      banners: [],
      carouselInstance: null,
    };
  },

  methods: {
    getInterval(imagen) {
      if (!imagen) return 5000;
      return imagen.toLowerCase().endsWith('.gif') ? 8000 : 2000;
    },

    modalvideobanner(videoUrl) {
      this.videoUrl = videoUrl;
      $('#playModal').modal('show');
    },

    handleModalShow() {
      const iframe = this.$refs.youtubeIframe;
      if (iframe) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          '*'
        );
      }
    },

    handleModalHide() { },

    cerrarModal() {
      $('#playModal').trigger('pause');
      $('#playModal').modal('hide');
    },

    changeBanner(index) {
      if (this.carouselInstance) {
        this.carouselInstance.to(index);
      } else {
        this.selectedBanner = index;
      }
    },

    goToPreviousBanner() {
      if (this.carouselInstance) {
        this.carouselInstance.prev();
      }
    },

    goToNextBanner() {
      if (this.carouselInstance) {
        this.carouselInstance.next();
      }
    },

    async obtenerBanners() {
      try {
        const response = await axios.get('/api/banners');
        this.banners = response.data || [];

        // cache de imágenes (opcional, respetando tu lógica)
        for (let banner of this.banners) {
          const cachedImage = await getCachedImage(`img/banners/${banner.image}`);
          if (cachedImage) {
            banner.cachedImage = cachedImage;
          } else {
            await cacheImage(`img/banners/${banner.image}`);
            banner.cachedImage = `img/banners/${banner.image}`;
          }
        }

        await this.$nextTick();

        // destruir instancia previa si existe
        if (this.carouselInstance) {
          try { this.carouselInstance.dispose(); } catch (e) { }
          this.carouselInstance = null;
        }

        const el = this.$refs.carouselEl;
        if (!el) return;

        this.carouselInstance = new Carousel(el, {
          interval: false, // usamos interval por slide
          ride: false,
          pause: false,
          wrap: true,
          touch: true,
        });

        // arrancar autoplay
        this.carouselInstance.cycle();

      } catch (error) {
        console.error('Error fetching banners:', error);
      }
    },
  },

  mounted() {
    this.obtenerBanners();
  },

  unmounted() {
    if (this.carouselInstance) {
      try { this.carouselInstance.dispose(); } catch (e) { }
      this.carouselInstance = null;
    }
  },
};
</script>
<style scoped>
.banners {
  margin-bottom: 2%;
}

@media (max-width: 576px) {
  .banners {
    margin-bottom: 12%;
  }
}

.custom-carousel {
  overflow: hidden;
  max-height: 80vh;
  /* La altura será la mitad de la ventana visible */
}

.imgbanner {
  height: 600px;
  object-fit: fill;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  color: #ff9900;
  /* Color de fondo de los iconos */
}

.carousel-indicators button {
  background-color: #ff9900;
  /* Color de fondo para los indicadores */
}

.carousel-indicators .active {
  background-color: #ff6600;
  /* Color de fondo para el indicador activo */
}

.youtube-button {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  text-decoration: none;
  color: #fff;
  background-color: #c4302b;
  border-radius: 4px;
  border: 1px solid #c4302b;
  transition: background-color 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 20px;
  right: 20%;
  /* Cambiado de left a right */
}

.youtube-button:hover {
  background-color: #e52d27;
  border-color: #e52d27;
}

.youtube-icon {
  margin-left: 8px;
  /* Cambiado de margin-right a margin-left */
  vertical-align: middle;
}

.bottom-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 30px;
  background: rgba(6, 40, 60, 0.8);
  color: #FFF;
  overflow: hidden;
  height: 5%;
}

.bottom-bar .title-container {
  float: left;
  font-weight: 100;
  font-size: 14px;
}

.bottom-bar .right {
  float: right;

}

@media (max-width: 768px) {
  .banners {
    margin-top: 12%;
  }

  .custom-carousel {
    overflow: hidden;
    max-height: 50vh;
    /* La altura será la mitad de la ventana visible */
  }

  .imgbanner {
    height: 250px;
    object-fit: fill;
  }

  .youtube-button {
    padding: 10px;
    /* Reducir el espacio alrededor de los botones */
    line-height: 0;
    /* Ocultar el texto */
  }

  .youtube-button i {
    margin-right: 8px;
    /* Espacio entre el icono y el borde del botón */
  }

}
</style>